import React from "react";
import { IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

interface SaveCancelButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  saveTitle?: string;
  cancelTitle?: string;
  containerStyle?: React.CSSProperties;
}

const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({
  onSave,
  onCancel,
  saveTitle = "Save",
  cancelTitle = "Cancel",
  containerStyle,
}) => {
  return (
    <div style={containerStyle}>
      <IconButton
        onClick={onSave}
        size="small"
        sx={{
          color: "#3969E7",
          backgroundColor: "rgba(57, 105, 231, 0.08)",
          padding: "6px",
          "&:hover": {
            backgroundColor: "rgba(57, 105, 231, 0.15)",
            color: "#2a52cf",
          },
          transition: "all 0.2s ease-in-out",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
        title={saveTitle}
      >
        <SaveIcon fontSize="small" />
      </IconButton>
      <IconButton
        onClick={onCancel}
        size="small"
        sx={{
          color: "#dc3545",
          backgroundColor: "#fff5f5",
          padding: "6px",
          "&:hover": {
            backgroundColor: "#f8d7da",
            color: "#721c24",
          },
          transition: "all 0.2s ease-in-out",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
        title={cancelTitle}
      >
        <CancelIcon fontSize="small" />
      </IconButton>
    </div>
  );
};

export default SaveCancelButtons;

